var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.78339V9.67157C6 10.3614 6.27405 11.0231 6.76187 11.5109V11.5109C7.24968 11.9987 7.52373 12.6603 7.52373 13.3502V18.0412C7.52373 18.8226 8.1572 19.456 8.93862 19.456V19.456C9.72005 19.456 10.3535 18.8226 10.3535 18.0412V13.3502C10.3535 12.6603 10.6276 11.9987 11.1154 11.5109V11.5109C11.6032 11.0231 11.8772 10.3614 11.8772 9.67157V3.78339",
    stroke: "#413958",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7435 4.1449C18.7435 3.95245 18.5528 3.81809 18.3716 3.88282L16.8447 4.42813C16.0886 4.69818 15.4397 5.20483 14.9943 5.87288V5.87288C14.5856 6.48606 14.3674 7.20652 14.3674 7.94346V12.61C14.3674 13.1013 14.5626 13.5726 14.9101 13.9201L15.304 14.314C15.5449 14.5549 15.6802 14.8816 15.6802 15.2223V17.9723C15.6802 18.8182 16.366 19.5039 17.2119 19.5039V19.5039C18.0578 19.5039 18.7435 18.8182 18.7435 17.9723V4.1449Z",
    stroke: "#413958",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93863 9.56218L8.93863 3.80563",
    stroke: "#413958",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.6bc4fe1378eb15a2bfb09f83ad693247.svg";
export { ForwardRef as ReactComponent };